import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { DataLayerFn } from "../../Configs/API";
import FormStore from "../../Configs/Store/forms";
import "../../styles/Quote/OptionalLead.less";
import CircleIcon from "../Common/CircleIcon";
import GenericModal from "../Common/GenericModal";
import Spinner from "../Common/Spinner";

const ORIGIN_URL =
  window.location.hostname === "localhost"
    ? "*"
    : `https://${window.location.hostname}`;

const OPTIONAL_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3011"
    : `https://${window.location.hostname}${
        window.location.hostname.includes("icicilife.com")
          ? window.location.href.includes("testing")
            ? process.env.REACT_APP_OPTL_IPU_UAT
            : process.env.REACT_APP_OPTL_IPU_PROD
          : window.location.href.includes("ec2")
            ? process.env.REACT_APP_OPTL_DEP_EC2
            : process.env.REACT_APP_OPTL_DEP_S3
      }?UID=${window.Glb_UID}`;

const OptionalLeadFrame = observer(({}) => {
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    if (FormStore.quote_OptionalLead) {
      setTimeout(() => {
        var OptionalBOOFrame =
          document.getElementById("OptionalBOOFrame").contentWindow;
        var Prefil = {
          OptionalLead: {
            email: FormStore.calc_email,
            number: FormStore.calc_phone,
          },
        };
        OptionalBOOFrame.postMessage(Prefil, ORIGIN_URL);
      }, 500);
    }
  }, [FormStore.quote_OptionalLead, Loading]);

  const handleClose = function () {
    FormStore.setOptionalLead(false);
    DataLayerFn(
      "OptionalLead_PoupClose||Calculator-QuoteScreen|Optional Lead Popup",
      FormStore,
      "",
      "x",
      "",
      "",
    );
  };

  return (
    <GenericModal
      visibleState={FormStore.quote_OptionalLead}
      updateVisibility={handleClose}
      closeIcon={
        <CircleIcon
          iconUrl={`assets/common/Path15589.svg`}
          iconStyle="closeIconModalMob"
        />
      }
      rootClassAntCustom={"OptionalLead"}
      showButton={false}
      closeIconVisible={true}
      buttonText={"CONTINUE"}
      buttonStyle={"Button"}
      buttonWrapper={"calculateFormDiv"}
      buttononClick={null}
      zIndex={1305}
      component={
        <Spinner
          msg={"Loading..."}
          loading={Loading}
          className={"OptionalLead_Spinner"}
        >
          <iframe
            onLoad={() => setLoading(false)}
            id="OptionalBOOFrame"
            name="OptionalBOOFrame"
            height="100%"
            width="100%"
            src={OPTIONAL_URL}
          ></iframe>
        </Spinner>
      }
    />
  );
});
export default OptionalLeadFrame;
